export default __webpack_public_path__ + "static/media/check-circle.5654a2a8.svg";